import { action as actionCreator } from "typesafe-actions";
import { asyncFailed, asyncHasFinished, asyncIsRunning, asyncNotStarted } from "@advosys/component-react-utils";
export var TimeTrackEntriesActionTypes;
(function (TimeTrackEntriesActionTypes) {
    TimeTrackEntriesActionTypes["GetTimeTrackEntriesRequest"] = "@@UNIK:domains:dynamic-invoice:pages:dynamic-invoice-page:components:dynamic-invoice-dialog:components:time-track-entries:time-track-entries-store:GetTimeTrackEntriesRequest";
    TimeTrackEntriesActionTypes["GetTimeTrackEntriesSuccess"] = "@@UNIK:domains:dynamic-invoice:pages:dynamic-invoice-page:components:dynamic-invoice-dialog:components:time-track-entries:time-track-entries-store:GetTimeTrackEntriesSuccess";
    TimeTrackEntriesActionTypes["GetTimeTrackEntriesFail"] = "@@UNIK:domains:dynamic-invoice:pages:dynamic-invoice-page:components:dynamic-invoice-dialog:components:time-track-entries:time-track-entries-store:GetTimeTrackEntriesFail";
    TimeTrackEntriesActionTypes["ClearTimeTrackEntries"] = "@@UNIK:domains:dynamic-invoice:pages:dynamic-invoice-page:components:dynamic-invoice-dialog:components:time-track-entries:time-track-entries-store:ClearTimeTrackEntries";
})(TimeTrackEntriesActionTypes || (TimeTrackEntriesActionTypes = {}));
export const actions = {
    getTimeTrackEntriesRequest: (preparedInvoiceId) => actionCreator(TimeTrackEntriesActionTypes.GetTimeTrackEntriesRequest, { preparedInvoiceId }),
    getTimeTrackEntriesSuccess: (matterLedgerEntries) => actionCreator(TimeTrackEntriesActionTypes.GetTimeTrackEntriesSuccess, { matterLedgerEntries }),
    getTimeTrackEntriesFail: (errorMessage) => actionCreator(TimeTrackEntriesActionTypes.GetTimeTrackEntriesFail, { errorMessage }),
    clearTimeTrackEntries: () => actionCreator(TimeTrackEntriesActionTypes.ClearTimeTrackEntries)
};
const initialState = {
    loading: asyncNotStarted
};
export const timeTrackEntriesReducer = (state = initialState, action) => {
    switch (action.type) {
        case TimeTrackEntriesActionTypes.GetTimeTrackEntriesRequest:
            return { ...state, loading: asyncIsRunning };
        case TimeTrackEntriesActionTypes.GetTimeTrackEntriesSuccess:
            return { ...state, loading: asyncHasFinished({ matterLedgerEntries: action.payload.matterLedgerEntries }) };
        case TimeTrackEntriesActionTypes.GetTimeTrackEntriesFail:
            return { ...state, loading: asyncFailed(action.payload.errorMessage) };
        case TimeTrackEntriesActionTypes.ClearTimeTrackEntries:
            return initialState;
        default:
            return state;
    }
};
